<template>
  <div>
    <div
      class="text-muted rounded-lg bg-white p-1"
      style="font-size: 10px; font-weight: bolder;"
    >
      Suggested Customers for same Municipality
    </div>
    <BOverlay
      :show="tableCustomers.busy"
      opacity="0.5"
    >
      <div
        class="d-flex flex-md-column gap-2 mt-2 suggested-customers scrollbar-5px p-1"
      >
        <router-link
          v-for="tableCustomer in tableCustomers.rows"
          :key="tableCustomer.id"
          :to="{
            name: 'admin.customers.profile',
            params: {
              customer: tableCustomer.id
            }
          }"
          :class="[
            'rounded-lg p-1 cursor-pointer min-w-md-125px min-w-175px suggestion-card', {
              'active': Number($route.params.customer) === Number(tableCustomer.id)
            }
          ]"
        >
          <div style="font-size: 12px; font-weight: bolder;">
            {{ tableCustomer.first_name }} {{ tableCustomer.last_name }}
          </div>
          <div
            style="font-size: 10px;"
          >
            {{ tableCustomer.barangay.barangay_name }}
          </div>
          <div
            class="text-right mt-3"
            style="font-size: 10px;"
          >
            {{ tableCustomer.mobile_number }}
          </div>
        </router-link>
      </div>
    </BOverlay>
    <div class="d-flex justify-content-between py-2">
      <BButton
        v-if="tableCustomers.currentPage > 1"
        size="sm"
        variant="primary"
        @click.prevent="previousSuggestions"
      >
        PREV
      </BButton>
      <div />
      <BButton
        v-if="tableCustomers.currentPage < tableCustomers.totalRows / tableCustomers.perPage"
        size="sm"
        variant="primary"
        @click.prevent="nextSuggestions"
      >
        NEXT
      </BButton>
    </div>
  </div>
</template>
<script>
import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

import { SAdminCustomer } from '@/services/admin'

export default {
  name: 'VAdminCustomerSuggestions',

  mixins: [
    MxMisc,
    MxFormatter
  ],

  props: {
    customer: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        province_id: '',
        municipality_id: ''
      })
    }
  },

  data () {
    return {
      tableCustomers: {
        busy: false,
        filter: {
          search: '',
          province: this.customer.province_id,
          municipality: this.customer.municipality_id
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        rows: [],
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-right stacked-full text-md-center' },
          { mobile: 6, key: 'action', class: 'text-center w-md-125px' },
          { mobile: 1, key: 'name', label: 'Name', class: 'min-w-md-250px', formatter: this.getFullName, sortable: true },
          { mobile: 3, key: 'province.province_name', label: 'Province', class: 'min-w-250px' },
          { mobile: 4, key: 'status', label: 'Status', class: 'min-w-80px text-right text-md-center' },
          { mobile: 5, key: 'updated_at', class: 'min-w-175px', formatter: this.dateTimeShortFormatter }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  methods: {

    async tableProvider () {
      this.tableCustomers.busy = true
      const payload = {
        page: this.tableCustomers.currentPage,
        per_page: this.tableCustomers.perPage,
        sort: this.tableCustomers.sortBy,
        sort_desc: this.tableCustomers.sortDesc,
        filter_text: this.tableCustomers.filter.search,
        province_id: this.customer.province_id,
        municipality_id: this.customer.municipality_id
      }

      return await SAdminCustomer.get(payload).then(
        ({ data }) => {
          this.tableCustomers.totalRows = data.total_rows
          this.tableCustomers.rows = data.items
          return data.items
        }
      ).catch(() => {
        this.tableCustomers.totalRows = 0
        this.tableCustomers.rows = []
        return []
      }).finally(() => {
        this.tableCustomers.busy = false
      })
    },

    previousSuggestions () {
      if (this.tableCustomers.currentPage > 1) {
        this.tableCustomers.currentPage--
        this.tableProvider()
      }
    },

    nextSuggestions () {
      if (this.tableCustomers.currentPage < this.tableCustomers.totalRows / this.tableCustomers.perPage) {
        this.tableCustomers.currentPage++
        this.tableProvider()
      }
    }
  }
}
</script>
<style lang="scss">
.suggested-customers {
  max-width: 100%;
  overflow-x: auto;
  max-height: 62vh;
  min-height: 95px;
}

@media (min-width: 768px) {
  .suggested-customers {
    max-width: 100%;
    overflow-x: auto;
    max-height: 62vh;
    min-height: 62vh;
  }
}

.suggestion-card {
  position: relative;
  background-color: var(--iq-card-bg);
  color: var(--iq-dark);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.suggestion-card.active::after {
  content: '';
  position: absolute;
  border: 10px solid var(--iq-primary-dark);
  left: -10px;
  bottom: 8px;
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-radius: 4px;
  transform: rotate(45deg);
}

.suggestion-card:hover, .suggestion-card.active {
  background-color: var(--iq-primary-light);
  color: var(--iq-dark-dark);
}

.dark {
  .suggestion-card {
    background-color: var(--iq-dark-card-bg);
  }

  .suggestion-card:hover , .suggestion-card.active {
    background-color: var(--iq-primary-dark);
    color: var(--iq-light);
  }
}
</style>
